import React, { Component } from 'react';
import { Card, Col, Container, Row } from 'react-bootstrap';
import { RouteComponentProps } from 'react-router-dom';

interface LocationState {
  isScheduled?: boolean;
}

class PaymentReceived extends Component<RouteComponentProps<{}, any, LocationState>> {
  render() {
    const isScheduled = this.props.location?.state?.isScheduled;

    const title = isScheduled ? 'Payment Scheduled' : 'Payment Complete';
    const message = isScheduled
      ? 'Thank you! Your payment has been scheduled successfully.'
      : 'Thank you! Your payment has been received!';

    return (
      <Container>
        <Card style={{ marginBottom: '50px' }}>
          <Card.Header
            className='text-center'
            style={{
              fontSize: '28px',
              color: 'white',
              backgroundColor: '#28a745'
            }}
          >
            {title}
          </Card.Header>
          <Card.Body>
            <Row>
              <Col style={{ display: 'flex', justifyContent: 'center', textAlign: 'center' }}>
                {message}
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Container>
    );
  }
}

export default PaymentReceived;
